export function hasRequiredValue(value: unknown): boolean {
    if (Array.isArray(value)) {
        return value.some((item) => hasRequiredValue(item));
    }

    if (value === null || value === undefined || value === '') {
        return false;
    }

    if (typeof value === 'object') {
        const objectValue = value as Record<string, unknown>;
        const keys = Object.keys(objectValue);
        if (keys.length === 0) {
            return false;
        }

        return keys.some((key) => hasRequiredValue(objectValue[key]));
    }

    return true;
}
